// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"jz-z","expressButtonContainerWithPayPal":"kz-z","expressButton":"lz-z","or":"mz-z"};